<div class="main-container mat-elevation-z10 slide-in" cdkDragLockAxis="x" cdkDrag data-cy="note-example-container">
  <div class="grip-handle" cdkDragHandle data-cy="note-example-grip-handle"><i class="material-icons">more_horiz</i></div>
  <!--<div class="close-button" (click)="closeNotes()"><i class="material-icons">cancel</i></div>-->
  <app-note-main [PatientID]="patientId"
                 [PatientName]="patientName"
                 [ObjectId]="ObjectId"
                 [ParentObjectName]="'dataPatient'"
                 data-cy="note-example-main"></app-note-main>
</div>


<!-- [ObjectId]="patientId" -->
